import React from "react";
import Icon from "../../components/AppIcon";
import SpinnerIcon from "../../components/ui/SpinnerIcon";

const BulkRejectModal = ({
  open,
  onClose,
  onSubmit,
  form,
  onFormChange,
  rejectionReasons = [],
  processing = false,
}) => {
  if (!open) return null;

  const handleReasonChange = (event) => {
    const { value } = event.target;
    onFormChange((prev) => ({ ...prev, reason_id: value }));
  };

  const handleRemarksChange = (event) => {
    const { value } = event.target;
    onFormChange((prev) => ({ ...prev, remarks: value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    onSubmit();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm px-4">
      <div className="w-full max-w-lg rounded-2xl bg-white shadow-2xl">
        <div className="flex items-center justify-between border-b border-gray-200 px-6 py-4">
          <div>
            <p className="text-sm font-semibold text-primary-600 uppercase tracking-wide">
              Bulk Action
            </p>
            <h3 className="text-xl font-bold text-gray-900">
              Reject Selected Workers
            </h3>
          </div>
          <button
            onClick={onClose}
            className="rounded-full p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-600"
          >
            <Icon name="X" size={18} />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="space-y-4 px-6 py-5">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Rejection Reason
              </label>
              <div className="relative">
                <select
                  value={form.reason_id}
                  onChange={handleReasonChange}
                  className="w-full appearance-none rounded-lg border border-gray-300 bg-white px-4 py-2.5 text-sm text-gray-900 focus:border-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-200"
                  required
                >
                  <option value="">Select a reason</option>
                  {rejectionReasons.map((reason) => (
                    <option key={reason.id} value={reason.id}>
                      {reason.reason || reason.name}
                    </option>
                  ))}
                </select>
                <Icon
                  name="ChevronDown"
                  size={16}
                  className="pointer-events-none absolute right-3 top-3 text-gray-400"
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Remarks (optional)
              </label>
              <textarea
                value={form.remarks}
                onChange={handleRemarksChange}
                rows={4}
                className="w-full rounded-lg border border-gray-300 px-4 py-2.5 text-sm text-gray-900 focus:border-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-200"
                placeholder="Provide additional context for the rejection..."
              />
            </div>

            <div className="rounded-lg bg-blue-50 px-4 py-3 text-sm text-blue-700">
              Selected workers will be marked as rejected with the selected
              reason. Applications with all workers rejected will automatically
              transition to a rejected state.
            </div>
          </div>

          <div className="flex items-center justify-end space-x-3 border-t border-gray-200 px-6 py-4">
            <button
              type="button"
              onClick={onClose}
              className="rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
              disabled={processing}
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={processing}
              className="inline-flex items-center rounded-lg bg-red-600 px-4 py-2 text-sm font-semibold text-white shadow hover:bg-red-700 disabled:cursor-not-allowed disabled:opacity-60"
            >
              {processing ? (
                <>
                  <SpinnerIcon />
                  <span className="ml-2">Processing...</span>
                </>
              ) : (
                <>
                  <Icon name="XCircle" size={16} className="mr-2" />
                  Confirm Reject
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BulkRejectModal;
